import useTranslator from "../../hooks/useTranslator";
import ProfileImg from "../../assets/img/profileImg.svg";
import noticIcon from "../../assets/img/noticIcon.svg";
import {
  cleanIdentityNumber,
  formatDateOfBirth,
  getIdentityDetails,
  getUserDisplayName,
  haveValue,
} from "../../helper/common";
import CheckIcon0 from "../../assets/img/checkIcon02.svg";
import { useState } from "react";
import constants from "../../Utils/constants";
import { Card } from "../design";
import "./tenantInfoCards.css";

const DetailsPersonalInfo = (props) => {
  const {
    user = null,
    forensicAnalysis = {},
    handleInfoModal,
    currentLang,
    llShowOnly,
  } = props;
  const { _t } = useTranslator();

  // Sending this true as we need to show the document_number or personal_number except spain, for spain case it works fine, for other we need that fallback.
  const needOnfidoResult = true;
  const kycDetails = getIdentityDetails(
    user,
    user?.onfido_user_kyc,
    needOnfidoResult
  );

  const isSameValue = (a, b) => {
    const cleanValueA = cleanIdentityNumber(a);
    const cleanValueB = cleanIdentityNumber(b);

    return haveValue(cleanValueA) && cleanValueA === cleanValueB;
  };

  const isOnfidoName = haveValue(
    user?.onfido_user_kyc?.onfido_doc_data?.first_name
  );

  const dniExtraValue = cleanIdentityNumber(
    forensicAnalysis?.DNI?.dataInJSON?.dni
  );
  const forensicIdentityType =
    typeof forensicAnalysis?.DNI?.dataInJSON?.type === "string"
      ? forensicAnalysis.DNI.dataInJSON.type.trim().toLowerCase()
      : "";
  const passportExtraValue = cleanIdentityNumber(
    forensicAnalysis?.Passport?.dataInJSON?.passportNumber
  );

  const isOnfidoNationality = haveValue(user?.nationality);
  const isForensicNationality =
    !isOnfidoNationality &&
    haveValue(forensicAnalysis?.Nationality?.dataInJSON?.nationality);
  const canOpenNationalityModal = isForensicNationality && llShowOnly;

  return (
    <>
      <Card
        className="tic-card"
        title={
          <span className="tic-card__title">
            <img src={ProfileImg} alt="" className="tic-card__icon" />
            {_t("personalInformation")}
          </span>
        }
      >
        <div className="row">
          {/* Name field */}
          <div className="col-md-4">
            <div
              className="tic-field"
              // ${
              // haveValue(forensicAnalysis?.Name) && llShowOnly
              //   ? "custom-tooltip cursor-pointer"
              //   : ""
              // }
              // `}
              // data-tooltip={_t("clickHereToSeeDetails")}
              // onClick={(e) => {
              //   if (haveValue(forensicAnalysis?.Name) && llShowOnly) {
              //     handleInfoModal(forensicAnalysis?.Name);
              //   }
              // }}
            >
              <div className="d-flex align-items-center gap-1">
                <p className="tic-field__label">{_t("name")}</p>
                <div className=" d-flex align-items-center gap-1">
                  {forensicAnalysis?.Name?.verifiedSource === true ||
                  isOnfidoName ? (
                    <img
                      src={CheckIcon0}
                      alt="Vector Icon"
                      className="tic-check"
                    />
                  ) : (
                    ""
                  )}
                </div>
              </div>
              <p className="tic-field__value">{getUserDisplayName(user)}</p>
            </div>
          </div>

          {haveValue(kycDetails?.value) && (
            <div className="col-md-4 col-6">
              <div className="tic-field">
                <div className="d-flex align-items-center gap-1">
                  <p className="tic-field__label">
                    {_t(
                      kycDetails?.isForeignId
                        ? "documentNumber"
                        : kycDetails?.type === "passport"
                          ? "passport"
                          : "dniNie"
                    )}
                  </p>
                  {kycDetails?.showTick && (
                    <div className="d-flex align-items-center gap-1">
                      <img
                        src={CheckIcon0}
                        alt="Vector Icon"
                        className="tic-check"
                      />
                    </div>
                  )}
                </div>

                <p className="tic-field__value">{kycDetails?.value ?? ""}</p>
              </div>
            </div>
          )}

          {/* Nationality field */}
          <div className="col-md-4 col-6">
            <div
              className={`tic-field ${
                canOpenNationalityModal ? "cursor-pointer custom-tooltip" : ""
              }`}
              data-tooltip={_t("clickHereToSeeDetails")}
              onClick={() => {
                if (canOpenNationalityModal) {
                  handleInfoModal(forensicAnalysis?.Nationality);
                }
              }}
            >
              <div className="d-flex align-items-center gap-1">
                <p className="tic-field__label">{_t("nationality")}</p>
                <div className=" d-flex align-items-center gap-1">
                  {isOnfidoNationality ||
                  (isForensicNationality &&
                    forensicAnalysis?.Nationality?.verifiedSource === true) ? (
                    <img
                      src={CheckIcon0}
                      alt="Vector Icon"
                      className="tic-check"
                    />
                  ) : (
                    ""
                  )}
                </div>
              </div>
              <p className="tic-field__value">
                {isOnfidoNationality
                  ? _t(user?.nationality, "", "fixed")
                  : isForensicNationality
                    ? _t(
                        forensicAnalysis?.Nationality?.dataInJSON?.nationality,
                        "",
                        "fixed"
                      )
                    : _t("na")}
              </p>
            </div>
          </div>

          {/* Phone Number field */}
          <div className="col-md-4 col-6">
            <div className="tic-field">
              <div className="d-flex align-items-center gap-1">
                <p className="tic-field__label">{_t("phoneNumber")}</p>
                <div className=" d-flex align-items-center gap-1">
                  {user?.phone_number_verified && (
                    <img
                      src={CheckIcon0}
                      alt="Vector Icon"
                      className="tic-check"
                    />
                  )}
                </div>
              </div>
              <p className="tic-field__value">
                {user?.phone_number ? `+${user?.phone_number}` : _t("na")}
              </p>
            </div>
          </div>

          {/* Email field */}
          <div className="col-md-4">
            <div className="tic-field">
              <div className="d-flex align-items-center gap-1">
                <p className="tic-field__label">{_t("email")}</p>
                <div className=" d-flex align-items-center gap-1">
                  <img
                    src={CheckIcon0}
                    alt="Vector Icon"
                    className="tic-check"
                  />
                </div>
              </div>
              <p className="tic-field__value">{user?.email}</p>
            </div>
          </div>

          {/* Date of Birth field */}
          {llShowOnly &&
            user?.employment_status?.toLowerCase() ===
              constants.employed.toLowerCase() && (
              <div className="col-md-4">
                <div className="tic-field">
                  <div className="d-flex align-items-center gap-1">
                    <p className="tic-field__label">{_t("dob")}</p>
                    <div className=" d-flex align-items-center gap-1">
                      <img
                        src={CheckIcon0}
                        alt="Vector Icon"
                        className="tic-check"
                      />
                    </div>
                  </div>
                  <p className="tic-field__value">
                    {formatDateOfBirth(user?.dob, currentLang)}
                  </p>
                </div>
              </div>
            )}

          {/* DNI/NIE Extra field */}
          {haveValue(dniExtraValue) &&
            !isSameValue(dniExtraValue, kycDetails?.value) && (
              <div className="col-md-4 col-6">
                <div
                  className={`tic-field ${
                    llShowOnly ? "custom-tooltip cursor-pointer" : ""
                  }`}
                  data-tooltip={_t("clickHereToSeeDetails")}
                  onClick={() => {
                    if (llShowOnly) {
                      handleInfoModal(forensicAnalysis?.DNI);
                    }
                  }}
                >
                  <div className="d-flex align-items-center gap-1">
                    <p className="tic-field__label">
                      {_t(
                        forensicIdentityType ===
                          constants.FORENSIC_DOCUMENT_TYPES.FOREIGN_NATIONAL_ID.toLowerCase()
                          ? "foreignNationalId"
                          : "dniNieExtra"
                      )}
                    </p>
                    {forensicAnalysis?.DNI?.verifiedSource === true && (
                      <div className="d-flex align-items-center gap-1">
                        <img
                          src={CheckIcon0}
                          alt="Vector Icon"
                          className="tic-check"
                        />
                      </div>
                    )}
                  </div>

                  <p className="tic-field__value">{dniExtraValue}</p>
                </div>
              </div>
            )}

          {/* Passport Extra field */}
          {haveValue(passportExtraValue) &&
            !isSameValue(passportExtraValue, kycDetails?.value) && (
              <div className="col-md-4 col-6">
                <div
                  className={`tic-field ${
                    llShowOnly ? "custom-tooltip cursor-pointer" : ""
                  }`}
                  data-tooltip={_t("clickHereToSeeDetails")}
                  onClick={() => {
                    if (llShowOnly) {
                      handleInfoModal(forensicAnalysis?.Passport);
                    }
                  }}
                >
                  <div className="d-flex align-items-center gap-1">
                    <p className="tic-field__label">{_t("passportExtra")}</p>
                    {forensicAnalysis?.Passport?.verifiedSource === true && (
                      <div className="d-flex align-items-center gap-1">
                        <img
                          src={CheckIcon0}
                          alt="Vector Icon"
                          className="tic-check"
                        />
                      </div>
                    )}
                  </div>

                  <p className="tic-field__value">{passportExtraValue}</p>
                </div>
              </div>
            )}
        </div>
      </Card>
    </>
  );
};

export default DetailsPersonalInfo;
